import { Link, Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { ProductFilterSortBar } from '../components/ProductFilterSortBar'
import { ProductCardGrid } from '../components/ProductCardGrid'
import { ProductGridSkeleton } from '../components/Skeleton'
import { SHOP_META } from '../constants/shop'
import { resolveShopTaxonSlug, taxonPageRoute } from '../helpers/catalog'
import { useShopCatalog } from '../hooks/useShopCatalog'
import '../styles/home-page.scss'
import '../styles/shop-page.scss'

export function ShopPage() {
  const { slug } = useParams<{ slug?: string }>()
  const { pathname } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()

  const taxonSlug = resolveShopTaxonSlug(pathname, slug)
  const pageRoute = taxonPageRoute(taxonSlug)

  const sort = searchParams.get('sort') ?? 'relevance'

  const { title, products, loading, error, missingCategory } = useShopCatalog(
    pageRoute ? '' : taxonSlug,
    { sort },
  )

  if (pageRoute) return <Navigate to={pageRoute} replace />

  function handleSortChange(nextSort: string) {
    const params = new URLSearchParams()
    if (nextSort && nextSort !== 'relevance') {
      params.set('sort', nextSort)
    }
    setSearchParams(params, { replace: true })
  }

  return (
    <div className="shop-page">
      <div className="container">
        <nav className="shop-page__crumbs" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden>›</span>
          <span aria-current="page">{title}</span>
        </nav>

        <header className="shop-page__head">
          <h1>{title}</h1>
        </header>

        {!loading && !error && !missingCategory && products.length > 0 && (
          <ProductFilterSortBar
            sort={sort}
            totalCount={products.length}
            onChange={handleSortChange}
          />
        )}

        {loading ? <ProductGridSkeleton /> : null}
        {error ? <p className="catalog-status catalog-status--error">{error}</p> : null}
        {!loading && !error && missingCategory ? (
          <p className="catalog-status">{SHOP_META.notFoundMessage}</p>
        ) : null}
        {!loading && !error && !missingCategory && products.length === 0 ? (
          <p className="catalog-status">{SHOP_META.emptyMessage}</p>
        ) : null}
        {!loading ? <ProductCardGrid products={products} /> : null}
      </div>
    </div>
  )
}
